var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.12268V9.75C10 11.545 8.54495 13 6.75 13C4.95508 13 3.5 11.545 3.5 9.75C3.5 7.95505 4.95508 6.5 6.75 6.5C7.00815 6.5 7.25925 6.5301 7.5 6.58697V8.1684C7.2727 8.0604 7.0184 8 6.75 8C5.7835 8 5 8.7835 5 9.75C5 10.7165 5.7835 11.5 6.75 11.5C7.7165 11.5 8.5 10.7165 8.5 9.75V3H10C10 4.38071 11.1193 5.5 12.5 5.5V7C11.5541 7 10.6848 6.67164 10 6.12268Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.d72d431b85fa613381fa926127dbb0a5.svg";
export { ForwardRef as ReactComponent };